export const getElement = (selector) => document.querySelector(selector);
export const getElements = (selector) => document.querySelectorAll(selector);
export const getValue = (selector) => getElement(selector)?.value || '';
export const setValue = (selector, value) => {
    const element = getElement(selector);
    if (element) element.value = value;
};
export const setHtml = (selector, html) => {
    const element = getElement(selector);
    if (element) element.innerHTML = html;
};
export const getDataAttribute = (element, attribute) => element?.getAttribute(`data-${attribute}`);
export const setDataAttribute = (element, attribute, value) => {
    if (element) element.setAttribute(`data-${attribute}`, value);
};
export const addClass = (selector, className) => {
    const element = getElement(selector);
    if (element) element.classList.add(className);
};
export const removeClass = (selector, className) => {
    const element = getElement(selector);
    if (element) element.classList.remove(className);
};
export const hasClass = (selector, className) => {
    const element = getElement(selector);
    return element ? element.classList.contains(className) : false;
};
export const show = (selector) => {
    const element = getElement(selector);
    if (element) element.style.display = '';
};
export const hide = (selector) => {
    const element = getElement(selector);
    if (element) element.style.display = 'none';
};
export const getText = (selector) => getElement(selector)?.textContent?.trim() || '';
export const setText = (selector, text) => {
    const element = getElement(selector);
    if (element) element.textContent = text;
};
export const addAttribute = (selector, attribute, value) => {
    const element = getElement(selector);
    if (element) element.setAttribute(attribute, value);
};
export const removeAttribute = (selector, attribute) => {
    const element = getElement(selector);
    if (element) element.removeAttribute(attribute);
};
export const focus = (selector) => {
    const element = getElement(selector);
    if (element) element.focus();
};
export const click = (selector) => {
    const element = getElement(selector);
    if (element) element.click();
};